import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDay } from "@/lib/format";
import { PageHeader, Spinner } from "@/components/rp";
import { Section } from "@/components/commesse";

const GROUPS = [
  ["ritardi", "Cantieri in ritardo sulla fine lavori", (r) => `Fine prevista ${fmtDay(r.date)} · ${r.days} giorni di ritardo`],
  ["difetti", "Difetti da sistemare scaduti", (r) => `${r.text} · entro ${fmtDay(r.date)}${r.responsabile ? ` · ${r.responsabile}` : ""}`],
  ["verbali", "Verbali di fine lavori da firmare", (r) => r.text + (r.date ? ` (inviato ${fmtDay(r.date.slice(0, 10))})` : "")],
  ["assistenza", "Problemi e assistenze aperte", (r) => `${r.source === "assistenza" ? "Assistenza" : "Problema"} dal ${fmtDay(r.date)} · ${r.text}`],
  ["documenti", "DURC e polizze RC subappaltatori (30 giorni)", (r) => `${r.text} · ${r.days < 0 ? "SCADUTO" : "scade"} il ${fmtDay(r.date)}`],
  ["garanzie", "Garanzie in scadenza (60 giorni)", (r) => `${r.text} · fino al ${fmtDay(r.date)}`],
];

export default function AdminAvvisi() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/avvisi").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!d) return <Spinner />;
  const groups = GROUPS.filter(([k]) => k !== "documenti" || d.can_view_docs);
  return (
    <div className="space-y-6" data-testid="admin-avvisi-page">
      <PageHeader label="Avvisi" title="Cosa controllare oggi" />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {groups.map(([k, l]) => (
          <a key={k} href={`#${k}`} className="rp-card p-4 hover:border-black transition-colors" data-testid={`avvisi-count-${k}`}>
            <p className={`text-3xl font-semibold ${d[k].length ? "" : "text-[#C8BDAB]"}`}>{d[k].length}</p>
            <p className="text-xs text-[#757575] mt-1">{l}</p>
          </a>
        ))}
      </div>
      {groups.map(([k, l, line]) => (
        <div id={k} key={k}>
          <Section label={l} testid={`avvisi-${k}`}>
            {!d[k].length && <p className="text-sm text-[#757575]">Tutto in ordine.</p>}
            {d[k].map((r, i) => (
              <Link key={`${r.order_id}-${r.id || i}`} to={`/admin/commesse/${r.order_id}`} className="block rounded-2xl border border-[#EBEBEB] p-3 mb-2 hover:border-black transition-colors" data-testid={`avvisi-${k}-item-${i}`}>
                <p className="text-sm font-medium">{r.code} · {r.title}</p>
                <p className="text-xs text-[#757575]">{r.client_name} · {line(r)}</p>
              </Link>
            ))}
          </Section>
        </div>
      ))}
      <p className="text-xs text-[#757575]">Ogni mattina alle 8:00 lo staff riceve un'email con ritardi, difetti scaduti e assistenze aperte da più di 3 giorni.</p>
    </div>
  );
}
